import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Modal, Col, Row, Table, Typography, notification, Space, Popover, Card, Select, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import Parameters from 'shared/parameters';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import { CurrencyFormatter, GetOrderTag } from 'shared/services/Utility';
import deFlag from '../../../src/img/de-icon.png';
import arrowLeft from '../../../src/img/arrow-left.png';
import activeBadge from '../../../src/img/active-badge.png';
import inactiveBadge from '../../../src/img/inactive-badge.png';
import { AuthConsumer } from 'shared/contexts/AuthContext';

// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

interface Props {
    location: any;
}

const { Title, Link } = Typography;
const { confirm } = Modal;
const { Option } = Select;
export default function StudentsReport(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [selectedOrg, setSelectedOrg] = useState(null as any);
    const [pagination, setPagination] = useState({ page: 1, per_page: '50' } as any);
    const [total, setTotal] = useState(0);
    const [items, setItems] = useState([] as any[]);
    const [organizations, setOrganizations] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const [lang, setlang] = useState('' as any);
    const RouteParams: any = useParams();
    const clickedCoursesUser = new URL(window.location.href).searchParams.get('courseClickedLoggedinUser');
    const columns = [
        {
            title: t('genDict.name'),
            key: 'name',
            dataIndex: 'name',
        },
        {
            title: t('genDict.email'),
            key: 'email',
            dataIndex: 'email',
        },
        {
            title: t('genDict.phone'),
            key: 'phone',
            dataIndex: 'phone',
        },

        {
            title: t('genDict.gender'),
            key: 'gender',
            dataIndex: 'gender',
        },


        {
            title: t('genDict.status'),
            key: 'status',
            dataIndex: 'status',
        },

        {
            title: t('genDict.createdAt'),
            key: 'created_at',
            dataIndex: 'created_at',
            render: (a: number) => moment(a).format(DATE_FORMAT_LONG),
        },
    ];
    const refreshItems = () => {
        setFetching(true);
        let params;
        if(clickedCoursesUser == 'true'){
            params = {
                ...pagination,
                filter_organization_id: selectedOrg,
                course_id : RouteParams['id'],
                order: 'DESC',
                order_by: 'id',
                clicked_courses: true,
            }
        }else{
            params = {
                ...pagination,
                filter_organization_id: selectedOrg,
                course_id : RouteParams['id'],
                order: 'DESC',
                order_by: 'id',
            }
        }
        API_SERVICE.fetchReports(params, 'students').then(({
                               data: {
                                   data: {
                                       count,
                                       current_page,
                                       items,
                                       per_page,
                                       total,
                                   },
                               },
                           }) => {
            setItems(items);
            setTotal(total);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#studentReportList').DataTable({
                    "language": {
                        "search": t('genDict.dataTableSearch'),
                      
                        "emptyTable": t('genDict.emptyTable'),
                        "lengthMenu": t('genDict.Show') + " _MENU_ " + t('genDict.entries'),
                        "paginate": {
                            "first":      t('genDict.first'),
                            "last":       t('genDict.last'),
                            "next":      t('genDict.next'),
                            "previous":   t('genDict.previous'),
                          },
                          "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                     
                      "infoEmpty": t('genDict.infoEmpty'),
                      }
                });
                // } ,1000);
            });
        }).catch(e => {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }).finally(() => {
            setFetching(false);

        });
    };
    const fetchOrganizations = async () => {
        setFetching(true);
        try {
            const {
                data: {
                    data: {
                        items: o,
                    },
                },
            } = await API_SERVICE.fetchOrganizations({ per_page: 1000, order_by: 'id', page: 1, order: 'DESC' });
            setOrganizations(o);
            if (o.length) {
                setSelectedOrg(o[0].id);
            }
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        if (Parameters.Mode === 'SUPER_ADMIN') {
            fetchOrganizations();
        } else {
            refreshItems();
        }
    }, []);
    useEffect(() => {
        if (selectedOrg) {
            refreshItems();
            setlang(localStorage.getItem('language'));
        }
    }, [selectedOrg, pagination, props.location]);
    if(fetching){
        return <Skeleton active={true} />
    }
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                <div className={'list-page-wrapper'}>
                    <div className="container-fluid">
                        <div className={'d-flex justify-space-between mb-3'}>
                            <div className='col-md-12 p-0 d-flex align-items-center'>
                                <div className={lang == 'ar' ? '' : 'mr-4'}>
                                <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                </div>
                                <div className={lang == 'ar' ? 'mr-2' : 'mr-2'}>
                                    {!RouteParams['id'] && <h3 className='mb-0'>{t('genDict.studentsReport')}</h3>}
                                    {RouteParams['id'] && !clickedCoursesUser && <h3 className='mb-0'>{t('genDict.Enrolled')} {t('genDict.studentsReport')}</h3>}
                                    {RouteParams['id'] && clickedCoursesUser && <h3 className='mb-0'>{t('genDict.courseClicked')} {t('genDict.studentsReport')}</h3>}
                                </div>
                            </div>
                            <div className='ml-auto'>
                                {
                                    Parameters.Mode === 'SUPER_ADMIN' && <Select value={selectedOrg} onChange={(e) => {
                                        setSelectedOrg(e);
                                        setPagination({ ...pagination, page: 1, total: 0 });
                                    }
                                    }>
                                        {
                                            organizations.map((o: any) => {
                                                return <Option value={o.id}>{o.name}</Option>;
                                            })
                                        }
                                    </Select>
                                }
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 p-0'>
                                <div className='bg-white p-3 br-5px'>
                                    <div className="row">
                                    <div className="col-md-12 pb-3">
                                        <div className="table-responsive table-br-5 box-shadow mt-2">
                                            <table id="studentReportList" className="table  table-meetings table-report">
                                            <thead>
                                                <tr>
                                                <th className="text-uppercase text-secondary">{t('genDict.StudentName')}</th>
                                                <th className="text-uppercase text-secondary">{t('genDict.email')}</th>
                                                <th className="text-uppercase text-secondary text-center">{t('genDict.ContactInfo')}</th>
                                                <th className="text-uppercase text-secondary text-center">{t('genDict.gender')}</th>
                                                {!RouteParams['id'] && <th className="text-uppercase text-secondary">{t('genDict.courses')}</th>}
                                                {!RouteParams['id'] && <th className="text-uppercase text-secondary">{t('genDict.CompletedCourses')}</th>}
                                                {!RouteParams['id'] && <th className="text-uppercase text-secondary">{t('genDict.clickedCourses')}</th>}
                                                {RouteParams['id'] && <th className="text-uppercase text-secondary">{t('genDict.CourseName')}</th>}
                                                {RouteParams['id'] && <th className="text-uppercase text-center text-secondary">{t('genDict.CourseCompletion')}</th>}
                                                {/* <th className="text-uppercase text-secondary text-center">Status</th> */}
                                                <th className="text-uppercase text-secondary">{t('genDict.AddIn')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    items && items.map(item => {
                                                        console.log(item);
                                                        return <tr>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                            {/* <div className="mr-3">
                                                                <img src={deFlag} className="uploaded-img-cat" height="40" width="40"/>
                                                            </div> */}
                                                            <div className="">
                                                                <p className="mb-0"><span>{item?.name}</span></p>
                                                            </div>
                                                            </div>
                                                        </td>
                                                        <td className="text-secondary">{item?.email}</td>
                                                        <td className="text-secondary text-center">{item?.phone}</td>
                                                        <td className="text-secondary text-center">{item?.gender}</td>
                                                        {!RouteParams['id'] && <td className="text-center">
                                                            <span role={item?.courses_purchased_count == 0 ? '' : 'button'} className={item?.courses_purchased_count == 0 ? 'text-secondary' : 'text-blue'} onClick={() => {
                                                                    if(item.courses_purchased_count != 0){
                                                                        history.push(`/reports/courses/${item?.id}?userType=student`)
                                                                    }
                                                                }}>
                                                                    {item?.courses_purchased_count}
                                                                </span>
                                                            {/* <a type="button" className="text-blue" data-toggle="modal" data-target={`#myModal${item.id}`}>
                                                            View Courses
                                                            </a>
                                                            <div className="modal" id={`myModal${item.id}`}>
                                                            <div className="modal-dialog centered m-0" style={{maxWidth:'500px',transform: "translate(-50%, -50%)"}}>
                                                                <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <h4 className="modal-title">Enrolled Courses</h4>
                                                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                                                </div>
                                                                <div className="modal-body">
                                                                {item.coursesOpted && item.coursesOpted.map((optedCourse:any) => {
                                                                    return <>{optedCourse && optedCourse.title ? optedCourse.title+', ':''}</>
                                                                })}
                                                                </div>
                                                                </div>
                                                            </div>
                                                            </div> */}
                                                        </td>}
                                                        {!RouteParams['id'] && <td className="text-center">
                                                            {item?.courses_completed_count}
                                                        </td>}
                                                        {!RouteParams['id'] && <td className="text-center">
                                                        <span role={item?.course_clicks_count == 0 ? '' : 'button'} className={item?.course_clicks_count == 0 ? 'text-secondary' : 'text-blue'} onClick={() => {
                                                            if(item.course_clicks_count != 0){
                                                                history.push(`/reports/courses/${item?.id}?clickedCourses=true`)
                                                            }
                                                        }}>
                                                            {item?.course_clicks_count}
                                                        </span>
                                                        </td>}
                                                        {RouteParams['id'] && <td className="text-secondary">
                                                            {item?.course_name}
                                                        </td>}
                                                        {RouteParams['id'] && <td className="text-center">
                                                            <div className="circle-small mt-4">
                                                                <a type='button' onClick={() => {
                                                                    history.push(`/reports/users/${item?.id}/course/${RouteParams['id']}`)
                                                                }}>
                                                                    <div className="text">{Math.round(item?.completion_percentage)}%</div> 
                                                                    <svg>
                                                                        <circle className="bg" cx="40" cy="40" r="37"></circle>
                                                                        <circle className="progress two" cx="40" cy="40" r="37" style={{strokeDashoffset: -(((232 * item?.completion_percentage)/100)-232)}}></circle>
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                        </td>}
                                                        {/* <td className="text-center">
                                                            {item?.status === 'ACTIVE' ? <img src={activeBadge}/> : <img src={inactiveBadge}/>}
                                                        </td> */}
                                                        <td className="text-secondary">{moment(item?.created_at).format('DD MMMM, YYYY')}</td>
                                                    </tr>
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    {/* <Row gutter={20} justify={'space-between'}>
                        <Col flex={'auto'}>
                            <Title level={3}>{t('genDict.studentsReport')}</Title>
                        </Col>
                        <Col>
                            {
                                Parameters.Mode === 'SUPER_ADMIN' && <Select value={selectedOrg} onChange={(e) => {
                                    setSelectedOrg(e);
                                    setPagination({ ...pagination, page: 1, total: 0 });
                                }
                                }>
                                    {
                                        organizations.map((o: any) => {
                                            return <Option value={o.id}>{o.name}</Option>;
                                        })
                                    }
                                </Select>
                            }
                        </Col>
                    </Row>
                    <Table loading={fetching} scroll={{ x: true }} pagination={{
                        onChange: (page, per_page) => {
                            setPagination({ ...pagination, page: page, per_page: per_page || pagination.per_page });
                        },
                        pageSize: pagination.per_page,
                        hideOnSinglePage: true,
                        total: total,
                    }} dataSource={items} columns={columns}/> */}
                </div>
                )
            }
        </AuthConsumer>
    );
}
